const Routes = {
	HOME: () => "/",
	// Asset Review
	ASSET_REVIEW: () => "/asset-review",
};

export default Routes;
